import { Button, useLocalization } from '@magicdoorinc/ui';
import { useNavigate } from '@solidjs/router';
import type { Component } from 'solid-js';

export const AccessDeniedFallback: Component = () => {
  const { t } = useLocalization();
  const navigate = useNavigate();

  return (
    <div class="flex h-full min-h-[600px] flex-col items-center justify-center p-8">
      <div class="flex max-w-md flex-col items-center text-center">
        <div class="bg-error/10 mb-6 flex size-32 items-center justify-center rounded-full">
          <svg class="size-16 text-danger" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
            />
          </svg>
        </div>

        <h2 class="mb-3 text-2xl font-semibold text-text-01">{t('Access Denied')}</h2>

        <p class="mb-2 text-base text-text-02">{t("You don't have permission to access this page or feature.")}</p>

        <p class="mb-8 text-sm text-text-03">
          {t('If you believe this is an error, please contact your administrator to request access.')}
        </p>

        <div class="flex gap-3">
          <Button variant="outlined" onClick={() => navigate(-1)}>
            {t('Go Back')}
          </Button>
          <Button onClick={() => navigate('/')}>{t('Back to Home')}</Button>
        </div>
      </div>
    </div>
  );
};
